export default __webpack_public_path__ + "static/media/service-relax.f4ecc7b4.png";